export default __webpack_public_path__ + "search-examples-mapbox-mapview-category-thumbnail-960-044034f56653b2e4387d6c12f283aab2.png";